import workspace from "../../workspace";

class ShapeAbsolute {
  __shape;
  __intersectionPoints = [];
  __minLengthToIntersectionPoints;
  __absolutePos = null;
  __snappedWithShape = null;
  __snappedShapeGroup = null;
  __pendingSnappedWithShapeId = null;

  constructor(shape) {
    this.__shape = shape;
  }
  setParentId(parentId) {
    this.__shape.shapeParentId = parentId
  }
  setRotationDegreesSlab(rotationDegrees) {
    this.__shape.rotatedDegreesSlab = rotationDegrees
  }
  setAbsolutePos = (pos) => {
    this.__absolutePos = pos;
  };
  getAbsolutePosition = () => {
    return this.__absolutePos;
  };
  getIntersectionPoints = () => { return this.__intersectionPoints; };
  setIntersectionsPoints = (points) => { this.__intersectionPoints = points; };

  setSnappedWithShape = (shape) => { this.__snappedWithShape = shape}
  getSnappedWithShape = () => { return this.__snappedWithShape }

  setSnappedShapeGroup = (shapeGroup) => { this.__snappedShapeGroup = shapeGroup}
  getSnappedShapeGroup = () => { return this.__snappedShapeGroup }

  setMinLengthToIntersectionPoints = (length) => {
    this.__minLengthToIntersectionPoints = length;
  };

  import = (data) => {
    const snappedWithShapeId = data && data.snappedWithShape
      ? data.snappedWithShape.id || data.snappedWithShape
      : null;

    this.__pendingSnappedWithShapeId = snappedWithShapeId;

    if (snappedWithShapeId) {
      const snappedWithShape = workspace.getShapeById(snappedWithShapeId);
      this.setSnappedWithShape(snappedWithShape);
    }

    this.setAbsolutePos(data ? data.absolutePosition : null);
    this.setIntersectionsPoints(data ? data.intersectionPoints : null);
    this.setSnappedShapeGroup(data ? data.snappedShapeGroup : null);
  }

  resolveImportedSnappedWithShape = () => {
    if (!this.__pendingSnappedWithShapeId || this.getSnappedWithShape()) {
      return;
    }

    const snappedWithShape = workspace.getShapeById(this.__pendingSnappedWithShapeId);
    this.setSnappedWithShape(snappedWithShape);
  }

  export = () => {
    const snappedWithShape = this.getSnappedWithShape();

    return {
      absolutePosition: this.getAbsolutePosition(),
      intersectionPoints: this.getIntersectionPoints(),
      snappedWithShape: snappedWithShape ? snappedWithShape.id : null,
      snappedShapeGroup: this.getSnappedShapeGroup(),
    }
  }
}

export default ShapeAbsolute
